import type React from 'react';
import { OptOutModal } from './OptOutModal';

interface RentReportingOptOutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOptOut: () => void;
}

export const RentReportingOptOutModal: React.FC<RentReportingOptOutModalProps> = ({ isOpen, ...props }) => {
  return <OptOutModal open={isOpen} {...props} type="rent-reporting" />;
};
